import React, { useState, useEffect } from "react"; // Thêm useState, useEffect
import { Link } from "react-router-dom";
import { ref, onValue, get } from "firebase/database"; // Import Firebase
import { db } from "../../../../assets/firebase/firebaseconfig"; // Đường dẫn config firebase của bạn
import "./styles.css";
import useScrollReveal from "../../../../assets/hooks/useScrollReveal/useScrollReveal";
import { createSlug } from "../../../../assets/js/slug";

const ProductSection = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Lấy dữ liệu từ Firebase
  useEffect(() => {
    const productsRef = ref(db, "products");
    const unsubscribe = onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // Chuyển object từ Firebase thành array
        const productList = Object.keys(data).map((key) => ({
          id: key,
          ...data[key],
        }));

        // Trộn ngẫu nhiên (Shuffle) và lấy 4 cái như logic cũ của bạn
        const shuffled = productList
          .sort(() => Math.random() - 0.5)
          .slice(0, 4);

        setProducts(shuffled);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const getRevealClass = (isVisible) =>
    `scroll-reveal-item ${isVisible ? "is-visible" : ""}`;

  if (loading)
    return <div className="text-center py-5">Đang tải sản phẩm...</div>;
  console.log("p", products);
  return (
    <section className="product-section">
      <h3 className="product__subtitle">CÁC SẢN PHẨM TẠI HABAKO M&E</h3>

      <div className="product__grid">
        {products.map((product, index) => {
          // Hook scroll reveal cần được gọi bên trong component con hoặc xử lý cẩn thận
          // Lưu ý: Việc gọi hook trong map() có thể gây cảnh báo trong React nếu không đúng quy tắc.
          // Ở đây tôi giữ nguyên logic cũ của bạn nhưng bọc nó trong một item component sẽ tốt hơn.
          return (
            <ProductItem
              key={product.id}
              product={product}
              index={index}
              getRevealClass={getRevealClass}
            />
          );
        })}
      </div>

      <div className="product__cta-wrapper">
        <Link to="/san-pham" className="product__view-more-btn">
          XEM THÊM TẤT CẢ SẢN PHẨM
        </Link>
      </div>
    </section>
  );
};

// Tách nhỏ Item để sử dụng Hook Reveal đúng quy tắc React
const ProductItem = ({ product, index, getRevealClass }) => {
  const [cardRef, isCardVisible] = useScrollReveal({ threshold: 0.3 });

  return (
    <div
      className={`${getRevealClass(isCardVisible)} product__card`}
      style={{ "--reveal-delay": `${index * 0.1}s` }}
      ref={cardRef}
    >
      <div className="product__image-wrapper">
        <img
          
          src={product.mediaUrl}
          alt={product.name}
          className="product__image"
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/300";
          }} // Nếu link lỗi thì hiện ảnh tạm
        />
      </div>

      <h5 className="product__title">{product.name}</h5>

      <p className="product__description">
        Thương hiệu:{" "}
        <span style={{ color: "blue" }}>
          {product.brand || "Đang cập nhật"}
        </span>
      </p>

      <Link to={`/san-pham/${product.slug || createSlug(product.name)}`} className="product__detail-btn">
        CHI TIẾT
      </Link>
    </div>
  );
};

export default ProductSection;
